import classNames from "classnames";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import CanvasIcon from "./CanvasIcon";
import { chipKey, useCanvasSelection } from "./canvas-selection";
import { ICON_PATHS } from "./step-look";

const CitedChips = ({ className }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.PROCESS);
  const CHIPS = t("CANVAS_EDITOR.CHIPS", { returnObjects: true }) || {};
  const KINDS = CHIPS.KINDS || {};
  const { chips, uncite } = useCanvasSelection();

  return (
    <div className={classNames("canvas-cited", className)}>
      <span className="canvas-cited__title">{CHIPS.TITLE}</span>
      {chips.map((chip) => (
        <span
          key={chipKey(chip)}
          className="canvas-cited__chip"
          title={chip.label}
        >
          <span className="canvas-cited__kind">{KINDS[chip.kind]}</span>
          <span className="canvas-cited__label">{chip.label}</span>
          <button
            type="button"
            className="canvas-cited__remove"
            aria-label={t("CANVAS_EDITOR.CHIPS.REMOVE", { label: chip.label })}
            onClick={() => uncite(chip)}
          >
            <CanvasIcon path={ICON_PATHS.close} size={12} strokeWidth={2.6} />
          </button>
        </span>
      ))}
    </div>
  );
};

CitedChips.propTypes = {
  className: PropTypes.string,
};

CitedChips.defaultProps = {
  className: undefined,
};

export default CitedChips;
